<template>
    <div class="result fix">
        <div class="conLeft fl w780">
            <auctionResult></auctionResult>
        </div>
        <div class="conRight padRight fr w380 borderLine">
            <div class="comInfo">
                <div class="comTitle comTitleLine">
                    <span class="auctionFont conTitle ">公司信息</span>
                </div>
                <companyInfo :list="companyInfoList"></companyInfo>
            </div>
            <div class="comInfo">
                <span class="auctionFont conTitle mtb17">用户服务</span>
                <service :list="serviceList"></service>
            </div>
        </div>
    </div>
</template>

<script>
import auctionResult from "../components/auctionResult/auctionResult";
import companyInfo from "../components/companyInfo";
import service from "../components/service";
import { postDetail } from '@/api/company'
import { mapActions, mapGetters } from "vuex";

export default {
    name: "result",
    data() {
        return {
            companyInfoList: {},
            serviceList: {}
        }
    },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageOrgMeta/getIsLoadIng",
            getData: "pageOrgMeta/getData",
        }),
    },
    //服务端渲染
    asyncData({ store,route }) {
        let params = {
            type:10,
            zone_name:route.params.name
        }
        return store.dispatch("pageOrgMeta/setOrgMeta", [params, () => {}]);
    },
    mounted() {
        const webNames = this.$router.history.current.params.name;
        this.postDetail(webNames);
        const webName = this.$route.params.name;
        if (!this.getIsLoadIng){
            let parmas = {
                type:10,
                zone_name:webName
            }
            this.setOrgMeta([parmas,()=>{
                this.filteData();
            }])
        }else{
            this.filteData();
        }
    },
    methods: {
        ...mapActions({
            setOrgMeta:"pageOrgMeta/setOrgMeta"
        }),
        filteData(){
            let data = this.$store.state["pageOrgMeta"]["data"]
            console.log(data,'pageOrgMeta')
            document.title = data.meta ? data.meta.title :'';
            let head = document.getElementsByTagName('head');
            this.isLoading = false
            if(!document.querySelector('meta[name=description]')){
                let meta = document.createElement('meta');
                meta.name = 'description';
                meta.content = data.meta ? data.meta.description : '';
                head[0].appendChild(meta)
            }else{
                document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
            }
        },
        postDetail(name) {
            postDetail({
                web_name: name
            }).then(res => {
                // 公司信息
                this.companyInfoList = {
                    organ_name: res.data.organ_name,
                    regiter_time: res.data.regiter_time,
                    auth_num: res.data.auth_num,
                    good_business: res.data.good_business,
                    core_business: res.data.core_business,
                    area: res.data.area,
                    art_num: res.data.art_num,
                    total_price: res.data.total_price,
                    miroblog_pic: res.data.miroblog_pic,

                }
                // 用户服务
                this.serviceList = {
                    service: res.data.service
                }
            })
        }
    },
    components:{
        auctionResult,
        companyInfo,
        service,
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
</style>